import './polyfills';

import './setBrandAttribute';
import './index.css';
import Root from './Root';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <Root />
  </StrictMode>
);

serviceWorker.unregister();
